<div class="overlay" [class.fade-out]="closing" *ngIf="previewProducts.length >= 6 && show">
  <div class="modal_m lucky-modal">

    <h2 class="headline"> {{ "spin and win" | transloco }} </h2>

    <div class="wheel-wrapper">
      <div class="pointer"></div>

      <div class="wheel" [style.transform]="'rotate(' + rotation + 'deg)'">

        <span class="icon i1">
          <img [src]="rewardProduct
              ? transformImageUrl(rewardProduct.image)
              : transformImageUrl(previewProducts[0]?.image)" class="wheel-icon">
        </span>

        <span class="icon i2">
          <img [src]="rewardProduct
              ? transformImageUrl(rewardProduct.image)
              : transformImageUrl(previewProducts[1]?.image)" class="wheel-icon">
        </span>

        <span class="icon i3">
          <img [src]="rewardProduct
              ? transformImageUrl(rewardProduct.image)
              : transformImageUrl(previewProducts[2]?.image)" class="wheel-icon">
        </span>

        <span class="icon i4">
          <img [src]="rewardProduct
              ? transformImageUrl(rewardProduct.image)
              : transformImageUrl(previewProducts[3]?.image)" class="wheel-icon">
        </span>

        <span class="icon i5">
          <img [src]="rewardProduct
              ? transformImageUrl(rewardProduct.image)
              : transformImageUrl(previewProducts[4]?.image)" class="wheel-icon">
        </span>

        <span class="icon i6">
          <img [src]="rewardProduct
              ? transformImageUrl(rewardProduct.image)
              : transformImageUrl(previewProducts[5]?.image)" class="wheel-icon">
        </span>

      </div>
    </div>

    <p class="result" *ngIf="resultText">
      {{ resultText }}
    </p>

    <p class="result" *ngIf="!rewardProduct && !spinning">
      {{ "you can win one of these gifts!" | transloco }}
    </p>

    <button class="spin-btn" *ngIf="!rewardProduct" (click)="spin()" [disabled]="spinning">
      {{ spinning ? ('SPINNING...' | transloco) : ('SPIN' | transloco) }}
    </button>

  </div>
</div>